export default "__VITE_ASSET__40967f96__"